// Shared "rule config" one-liner for sales tasks, used by both the task form
// (below the student name) and the list page's Task column:
//
//   [Rule name] - [Day from last transition activity] - [generated date]
//   e.g. "No book - Day 1 - 17 july 2026"
//
// Day N is the rule's configured day offset (sales_task_list.rule_day) counted
// from the rule's anchor — the student's last transition activity (signup date
// for signup-anchored rules, the latest concierge-bucket entry for
// bucket-anchored ones). Day 0 = generated on the day of the transition, Day 1
// = the day after, matching the generator's due_date = anchor + rule_day
// semantics. The generated date is the task row's created date, rendered
// "17 july 2026" (lowercase month per the spec example).
import moment from 'moment-timezone';

const rule_config_line = (task_label, rule_day, created_date) => {
  const parts = [task_label || '—'];
  if (rule_day !== undefined && rule_day !== null) parts.push(`Day ${rule_day}`);
  if (created_date) {
    const m = moment(created_date);
    if (m.isValid()) parts.push(m.format('D MMMM YYYY').toLowerCase());
  }
  return parts.join(' - ');
};

export default rule_config_line;
